const styles = theme => ({
  container: {
    borderRadius: '8px',
    padding: '20px 12px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: theme.palette.common.white,
    gap: '20px',
  },
  containerEquip: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    minHeight: 0,
  },
  '@global': {
    '.fullscreen': {
      // overflow: 'hidden !important',
      height: '100%',
      width: '100%',
    },
  },
  wrapperHeaderEquip: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  containerWrapper: {
    overflow: 'auto',
    backgroundColor: theme.palette.common.white,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    height: '100%',
    maxHeight: '100%',
  },
});

export default styles;
